import React, { useState, useEffect } from "react";
import { Link, useLocation, useParams, useNavigate } from "react-router-dom";
import { Button, Form, Card } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faSave } from "@fortawesome/free-solid-svg-icons";
import useFetch from "../../../../hooks/useFetch";
import Swal from "sweetalert2";

export default function Autor() {
    const navigate = useNavigate();
    const { get, post, put } = useFetch();
    const location = useLocation();
    const { id } = useParams();

    const [state, setState] = useState({
        acao: location.state?.acao || (id === "criar" ? "Criar" : "Visualizar"),
        autor: { nome: "", nacionalidade: "", data_nascimento: "", data_falecimento: "" }
    });

    useEffect(() => {
        if (id !== "criar") {
            get("/autorfotografo/" + id).then(response => {
                if (response.ok) setState(s => ({ ...s, autor: response.result.data }));
            });
        }
    }, [id]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setState(prev => ({ ...prev, autor: { ...prev.autor, [name]: value } }));
    };

    async function salvar() {
        let method = state.acao === "Criar" ? post : put;
        let url = state.acao === "Criar" ? `/autorfotografo` : `/autorfotografo/${id}`;
        
        try {
            let response = await method(url, state.autor);
            if (response.ok) {
                Swal.fire({ title: "Sucesso!", text: "Autor salvo com sucesso!", icon: "success" });
                navigate("/admin/iconografico/autores");
            } else {
                Swal.fire({ title: "Erro", text: "Erro ao salvar autor.", icon: "error" });
            }
        } catch (error) { console.error(error); }
    }

    return (
        <div className="admin-page-container">
            <div className="mb-4">
                <Link to="/admin/iconografico/autores" className="btn-back-modern">
                    <FontAwesomeIcon icon={faAngleLeft} className="me-2" /> Voltar aos Autores
                </Link>
            </div>

            <Card className="filter-card-admin">
                <Card.Body className="p-4 p-md-5">
                    <div className="section-title-modern mb-5">
                        <div className="title-accent"></div>
                        <div>
                            <h2 className="admin-title">{state.acao} Autor/Fotógrafo</h2>
                            <p className="admin-subtitle small mb-0">Informações biográficas do autor da obra</p>
                        </div>
                    </div>

                    <Form>
                        <div className="row g-4">
                            <Form.Group className="col-md-8">
                                <Form.Label className="label-admin">* Nome Completo ou Atribuído</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    name="nome"
                                    value={state.autor.nome} 
                                    onChange={handleChange} 
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-4">
                                <Form.Label className="label-admin">Nacionalidade</Form.Label>
                                <Form.Control 
                                    className="input-moderno" 
                                    name="nacionalidade"
                                    value={state.autor.nacionalidade} 
                                    onChange={handleChange} 
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Data de Nascimento / Início Atividade</Form.Label>
                                <Form.Control 
                                    type="date"
                                    className="input-moderno" 
                                    name="data_nascimento"
                                    value={state.autor.data_nascimento} 
                                    onChange={handleChange} 
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>

                            <Form.Group className="col-md-6">
                                <Form.Label className="label-admin">Data de Falecimento (se houver)</Form.Label>
                                <Form.Control 
                                    type="date"
                                    className="input-moderno" 
                                    name="data_falecimento"
                                    value={state.autor.data_falecimento} 
                                    onChange={handleChange} 
                                    disabled={state.acao === "Visualizar"}
                                />
                            </Form.Group>
                        </div>

                        {state.acao !== "Visualizar" && (
                            <div className="d-flex justify-content-end mt-5 pt-3 border-top">
                                <Button className="btn-apply-filters px-5" onClick={salvar}>
                                    <FontAwesomeIcon icon={faSave} className="me-2" /> Salvar Autor
                                </Button>
                            </div>
                        )}
                    </Form>
                </Card.Body>
            </Card>
        </div>
    );
}